import { Banner } from './MultiHistoricalReviewComponents.RightPane.Banner';
import { Content } from './MultiHistoricalReviewComponents.RightPane.Content';
import { Root } from './MultiHistoricalReviewComponents.RightPane.Root';
import { Footer } from './MultiHistoricalReviewComponents.Footer';
import { ConfirmationModal } from './MultiHistoricalReviewComponents.ConfirmationModal';

export const MultiHistoricalReviewComponents = {
  RightPane: {
    Root,
    Banner,
    Content,
  },
  Footer,
  ConfirmationModal,
};
